import customAxios from "./axiosConfig";

const ProductService = {
  list: function (params) {
    return customAxios.get(window.Urls["product-list"](),  { params: params });
  },
  create: function(data) {
    var url = window.Urls["product-list"]();
    const config = {
        headers: { 'content-type': 'multipart/form-data' },
    };
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
    return customAxios.post(url, getFormData(data), config).then(function(response){
        window.mixpanel.track("Product: create");
        return response;
    });
  },
  update: function (pk, data) {
    var url = window.Urls["product-detail"](pk);
    return customAxios.put(url, data)
        .then(function(response){
            window.mixpanel.track("Product: edit");
            return response;
        });
  },
  destroy: function (pk) {
    var url = window.Urls["product-detail"](pk);
    return customAxios.delete(url)
        .then(function(response){
            window.mixpanel.track("Product: delete");
            return response;
        });

  }
};

export default ProductService ;